export const INotificationsProfileCompletion = Object.freeze({
  isProfileCompleted: "is_profile_completed",
  isCriteriaViewed: "is_criteria_viewed",
  isExperienceCompleted: "is_experience_completed",
  isDescriptionCompleted: "is_description_completed",
  isCoursesCompleted: "is_courses_completed",
  isLanguagesCompleted: "is_languages_completed",
  isAeFolderCompleted: "is_ae_folder_completed",
  isSkillsCompleted: "is_skills_completed",
  isProfilePictureUploaded: "is_profile_picture_uploaded",
});

export class NotificationsProfileModel {
  constructor(data = {}) {
    this[INotificationsProfileCompletion.isProfileCompleted] = data[INotificationsProfileCompletion.isProfileCompleted];
    this[INotificationsProfileCompletion.isCriteriaViewed] = data[INotificationsProfileCompletion.isCriteriaViewed];
    this[INotificationsProfileCompletion.isExperienceCompleted] = data[INotificationsProfileCompletion.isExperienceCompleted];
    this[INotificationsProfileCompletion.isDescriptionCompleted] = data[INotificationsProfileCompletion.isDescriptionCompleted];
    this[INotificationsProfileCompletion.isCoursesCompleted] = data[INotificationsProfileCompletion.isCoursesCompleted];
    this[INotificationsProfileCompletion.isLanguagesCompleted] = data[INotificationsProfileCompletion.isLanguagesCompleted];
    this[INotificationsProfileCompletion.isAeFolderCompleted] = data[INotificationsProfileCompletion.isAeFolderCompleted];
    this[INotificationsProfileCompletion.isSkillsCompleted] = data[INotificationsProfileCompletion.isSkillsCompleted];
    this[INotificationsProfileCompletion.isProfilePictureUploaded] = data[INotificationsProfileCompletion.isProfilePictureUploaded];
  }

  isProfileComplete() {
    return this[INotificationsProfileCompletion.isProfileCompleted];
  }

  isCriteriaViewed() {
    return this[INotificationsProfileCompletion.isCriteriaViewed];
  }

  isExperienceCompleted() {
    return this[INotificationsProfileCompletion.isExperienceCompleted] ?? true; // if not present, it's not required because the user is a beginner
  }

  isDescriptionCompleted() {
    return this[INotificationsProfileCompletion.isDescriptionCompleted];
  }

  isCoursesCompleted() {
    return this[INotificationsProfileCompletion.isCoursesCompleted];
  }

  isLanguagesCompleted() {
    return this[INotificationsProfileCompletion.isLanguagesCompleted];
  }

  isAeFolderCompleted() {
    return this[INotificationsProfileCompletion.isAeFolderCompleted] ?? true; // if not present, it's completed or not required
  }

  isSkillsCompleted() {
    return this[INotificationsProfileCompletion.isSkillsCompleted];
  }

  isProfilePictureUploaded() {
    return this[INotificationsProfileCompletion.isProfilePictureUploaded];
  }

  shouldDisplayCvBadge() {
    return (
      !this.isExperienceCompleted() ||
      !this.isDescriptionCompleted() ||
      !this.isCoursesCompleted() ||
      !this.isLanguagesCompleted() ||
      !this.isSkillsCompleted()
    );
  }

  shouldDisplayMenuBadge() {
    return this.shouldDisplayCvBadge() || !this.isCriteriaViewed() || !this.isProfilePictureUploaded() || !this.isAeFolderCompleted();
  }
}
